/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum taxStatusEnum {
    NOT_STARTED = 'not_started',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    ALL = 'all',
}